import { Provider } from '@angular/core';
import { SECONDARY_MENU } from '@nx-icilalune/data/icilalune/tokens';
import { select, Store } from '@ngrx/store';
import { selectMenu } from '@nx-icilalune/data/access';

export const SECONDARY_MENU_PROVIDERS: Provider[] = [
  {
    provide: SECONDARY_MENU,
    deps: [Store],
    useFactory: (store: Store<any>) => {
      return store.pipe(select(selectMenu('secondary')));
    },
  },
];
